import { ApprovalState } from '@lichtblick/types';

import { Bar, BarContainer, RootContainer } from './TaskProgressBar.styles';

type ProgressBarWorkItem = {
  approvalState: ApprovalState;
  id: string;
};

type ProgressBarProps = {
  onBarClick?: (itemId: string) => void;
  workItems: ProgressBarWorkItem[] | null | undefined;
};

export const TaskProgressBar = ({ onBarClick, workItems }: ProgressBarProps) => {
  return (
    <RootContainer>
      <BarContainer>
        {workItems?.map((item) => {
          return (
            <Bar
              $status={item.approvalState}
              data-testid="task-progress-bar-item"
              key={`work-item-${item.id}`}
              onClick={() => onBarClick?.(item.id)}
            />
          );
        })}
      </BarContainer>
    </RootContainer>
  );
};
